import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-library/template";
const TRIGGER = "/reminder-builder/reminder-library/trigger";

// tbl_rem_template. Write calls and Render preview (which reads live rows) are Super Admin only.
const apiReminderTemplate = {
  create:              (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:              (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:              (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById:             (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:              (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // { id } or unsaved { channel_fid, trigger_fid, content, digest_content }, + param_values, timezone.
  renderPreview:       (payload)     => axiosClient.post(`${BASE}/render-preview`, payload),
  clone:               (id)          => axiosClient.post(`${BASE}/clone/${id}`),
  // Placeholders: a trigger's, or the system ones for a generic template.
  getTriggerVariables: (id)          => axiosClient.get(`${TRIGGER}/get-variables/${id}`),
  getSystemVariables:  ()            => axiosClient.get(`${TRIGGER}/get-system-variables`),
};

export default apiReminderTemplate;
